import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/cms/ui/dialog";
import LureoButton from '@/common/LureoButton';

interface TemplateExistingVersionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContinueExisting: () => void;
  onStartFresh: () => void;
  templateName?: string;
  copyName?: string | null;
}

export function TemplateExistingVersionDialog({
  open,
  onOpenChange,
  onContinueExisting,
  onStartFresh,
  templateName = "this template",
  copyName
}: TemplateExistingVersionDialogProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleContinueExisting = async () => {
    setIsLoading(true);
    try {
      await onContinueExisting();
    } finally {
      setIsLoading(false);
      onOpenChange(false);
    }
  };

  const handleStartFresh = async () => {
    setIsLoading(true);
    try {
      await onStartFresh();
    } finally {
      setIsLoading(false);
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="cursor-default select-none">
        <DialogHeader>
          <DialogTitle>Continue Existing Version?</DialogTitle>
          <DialogDescription>
            You have a copy of {templateName} in My Templates{copyName && copyName !== templateName ? ` called "${copyName}"` : ''}. Would you like to continue from where you left off, or discard that copy and start fresh?
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <LureoButton
            variant="outline-2"
            suppressTooltip
            onClick={handleContinueExisting}
            className="h-9 px-5 rounded-lureo-radius-button-pill"
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : "Continue"}
          </LureoButton>
          <LureoButton
            variant="secondary"
            suppressTooltip
            onClick={handleStartFresh}
            className="h-9 px-4 rounded-lureo-radius-button-pill"
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : "Start Fresh"}
          </LureoButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

